//查看最接近哪个
function closeTo(arr, num) {
    var newArr = [];
    arr.map(function (x) {
        newArr.push(Math.abs(x - num));
    });
    var index = newArr.indexOf(Math.min.apply(null, newArr));
    return arr[index];
}

//图片处理
function formatImage(src) {
    if (!src) {
        return src;
    }
    const isDev = process.env.NODE_ENV === 'development';
    const ossPrefix = 'lvshuhualv.oss-cn-hangzhou.aliyuncs.com';
    if (isDev) {
        if (/^https?:\/\//i.test(src)) {
            const url = new URL(src);
            if (url.host === ossPrefix) {
                return '/oss' + url.pathname + url.search;
            }
            return encodeURI(src);
        }
        if (src.startsWith('//')) {
            const url = new URL('https:' + src);
            if (url.host === ossPrefix) {
                return '/oss' + url.pathname + url.search;
            }
            return encodeURI(src);
        }
        return encodeURI('/oss/' + src.replace(/^\/+/, ''));
    }
    if (/^https?:\/\//i.test(src) || src.startsWith('//')) {
        return encodeURI(src);
    }
    return encodeURI('//lvshuhualv.oss-cn-hangzhou.aliyuncs.com/' + src);
}

//删除
function reomveObjectFromScene(scene, object) {
    scene.remove(object);
    object.geometry.dispose();
    if (object.material.map) {
        object.material.map.dispose();
    }
    object.material.dispose();
    object = null;
}

function disposeThreeNode(node) {
    if (!node) {
        return;
    }
    if (node.geometry) {
        node.geometry.dispose();
    }
    const materials = Array.isArray(node.material) ? node.material : [node.material];
    for (let material of materials) {
        if (!material) {
            continue;
        }
        for (let key in material) {
            if (material[key] && material[key].isTexture) {
                material[key].dispose();
            }
        }
        material.dispose();
    }
}

function removeTreeFromScene(scene, object) {
    if (!object) {
        return;
    }
    scene.remove(object);
    object.traverse(disposeThreeNode);
}

//选中花
function selectFlower(event) {
    let pointer = new THREE.Vector2(),
        ray = new THREE.Raycaster();
    let objects = [];
    for (let obj of this.objects.flowers) {
        if(!this.params.showId || (this.params.showId && this.params.showId === obj.id))
        objects.push(obj.modelMesh.flowerMesh);
    }
    pointer.x = (event.offsetX / this.params.dom.clientWidth) * 2 - 1;
    pointer.y = -(event.offsetY / this.params.dom.clientHeight) * 2 + 1;
    ray.setFromCamera(pointer, this.three.camera);

    const raycasterObjs = ray.intersectObjects(objects);
    if (raycasterObjs.length) {
        let activeObject = raycasterObjs[0].object;
        this.selectFlowerById(activeObject.parentObject.id, event);
    } else if (event.type === 'pointerdown') {
        this.clearFlowerSelection();
    }
}

export { closeTo, formatImage, reomveObjectFromScene, removeTreeFromScene, selectFlower };
